import Vue from 'vue'
import Vuex from 'vuex'
import upload from "@/server/index"

Vue.use(Vuex)

/* 测试数据 */
const date = 'Mon Oct 17 2016 00:00:00 GMT+0800 (中国标准时间)'
const ruleForm = {
}
const state = {
    isShow: false,
    action: upload.uploadImage(),
}

const mutations = {
    close:function(state, staur){
        state.isShow = staur;
    },
}

const actions = {

    close:function({commit}, isShow){
        commit('close', isShow);
    },
}

const getters = {
    close:function(){
        return state.isShow;
    },

}
export default  new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})



// WEBPACK FOOTER //
// ./src/store/store.js